import React from "react";
import "../Styles/CustomCard.css";

const CustomCard = ({ title, content, image, cta = false }) => {
  return (
    <article className="custom-card">
      <div className="custom-card-image">
        <img src={image} alt="" loading="lazy" />
        <div className="custom-card-title-container">
          <h3 className="custom-card-title">{title}</h3>
        </div>
      </div>
      <div className="custom-card-content">
        <div className={`custom-card-text${cta ? " custom-card-text--cta" : ""}`}>
          {content}
        </div>
      </div>
    </article>
  );
};

export default CustomCard;
